"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Format digital collection for client FE
 * Format digital collection api module
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.BasketItemStatusCodeEnum = void 0;
/**
 *
 * @export
 * @enum {string}
 */
var BasketItemStatusCodeEnum;
(function (BasketItemStatusCodeEnum) {
    BasketItemStatusCodeEnum["OutOfStock"] = "OUT_OF_STOCK";
    BasketItemStatusCodeEnum["PriceChanged"] = "PRICE_CHANGED";
    BasketItemStatusCodeEnum["InsufficientBalance"] = "INSUFFICIENT_BALANCE";
    BasketItemStatusCodeEnum["NotFound"] = "NOT_FOUND";
    BasketItemStatusCodeEnum["NotObtainable"] = "NOT_OBTAINABLE";
    BasketItemStatusCodeEnum["Valid"] = "VALID";
})(BasketItemStatusCodeEnum = exports.BasketItemStatusCodeEnum || (exports.BasketItemStatusCodeEnum = {}));
